export const projects = [
  {
    id: '1',
    title: 'Course platform',
    description: 'A full-stack course platform with user authentication, product catalog, and payment processing.',
    imageUrl: 'https://via.placeholder.com/600x400/1a1a1a/61dafb?text=E-commerce+Project',
    githubUrl: 'https://github.com/DeRigonato/courseflix'
  },
  {
    id: '2',
    title: 'DevBook',
    description: 'Built a simple social media backend using Go and MySQL. The project includes a basic HTML/CSS/JS front-end for API interaction.',
    imageUrl: 'https://via.placeholder.com/600x400/1a1a1a/61dafb?text=Task+Management',
    githubUrl: 'https://github.com/DeRigonato/DevBook'
  }
];